<template>
  <section class="invoice-preview-wrapper">
    <b-card
      no-body
      class="invoice-preview-card"
    >
      <b-card-body class="invoice-padding pb-0">
        <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
          <!-- Header: Left Content -->
          <div>
            <div class="logo-wrapper">
              <h3 class="text-primary invoice-logo">
                {{ formData.title }}
              </h3>
            </div>
            <p class="card-text mb-25">
              {{ formData.customer_company }}
            </p>
            <p class="card-text mb-25">
              {{ formData.customer_name }}
            </p>
            <p class="card-text mb-0">
              {{ formData.customer_phone }}
            </p>
            <p class="card-text mb-0">
              {{ formData.customer_email }}
            </p>
          </div>

          <!-- Header: Right Content -->
          <div class="mt-md-0 mt-2">
            <h4 class="invoice-title">
              Teklif No
              <span class="invoice-number">#{{ formData.onum }}<span
                v-if="formData.onum_rno"
                class="text-danger"
              >R{{ formData.onum_rno }}</span></span>
            </h4>
            <div class="invoice-date-wrapper d-inline-flex">
              <span class="invoice-date-title font-weight-bold mr-1">
                Teklif Tarihi:
              </span>
              <span class="invoice-date">
                {{ moment(formData.odate).format('DD.MM.YYYY') }}
              </span>
            </div>
            <hr class="clearfix">
            <div class="invoice-date-wrapper d-block d-inline-flex">
              <span class="invoice-date-title font-weight-bold mr-1">
                Durum:
              </span>
              <span class="invoice-date">
                {{ formData.offer_status }}
              </span>
            </div>
          </div>
        </div>
      </b-card-body>
      <b-card-body>
        <b-row>
          <b-col
            md="12"
          >
            <b-form-group label="Teklif Başlık">
              <b-form-input
                v-model="formData.title"
                placeholder="Teklif Başlık"
              />
            </b-form-group>
          </b-col>
          <b-col
            md="12"
          >
            <b-form-group label="İlgili Kişi">
              <b-form-input
                v-model="formData.name"
                placeholder="İlgili Kişi"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Teklif No">
              <b-form-input
                v-model="formData.onum"
                placeholder="Teklif No"
                readonly
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Teklif Tarihi">
              <b-form-datepicker
                id="example-i18n-picker"
                v-model="formData.odate"
                v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
                locale="tr"
                start-weekday="1"
                class="mb-1"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Durum">
              <v-select
                v-model="formData.id_offer_status"
                label="title"
                :reduce="offer_status => offer_status.id"
                placeholder="Durum"
                :options="offerStatuses"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Teslim Süresi">
              <b-form-input
                v-model="formData.delivery_time"
                placeholder="Teslim Süresi"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Teslim Yeri">
              <b-form-input
                v-model="formData.delivery_location"
                placeholder="Teslim Yeri"
              />
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="4"
          >
            <b-form-group label="Ödeme">
              <b-form-input
                v-model="formData.payment"
                placeholder="Ödeme"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <hr class="invoice-spacing">
      <b-table
        v-if="linesData.length > 0"
        hover
        :fields="fields"
        :items="linesData"
      >
        <template #cell(text)="data">
          <b-button
            v-b-modal.modal-line-edit
            variant="flat-primary"
            class="btn-icon"
            size="sm"
            pill
            @click="getOfferLine(data.item.id)"
          ><FeatherIcon icon="EditIcon" /></b-button>
          {{ data.item.text }}
        </template>
        <template #cell(quantity)="data">
          <div class="text-center">
            {{ data.item.quantity }} {{ data.item.unit }}
          </div>
        </template>
        <template #cell(product_price)="data">
          <div class="text-center">
            {{ priceFormater(data.item.product_price) }} {{ data.item.currency_symbol }}
          </div>
        </template>
        <template #cell(labor_price)="data">
          <div class="text-center">
            {{ priceFormater(data.item.labor_price) }} {{ data.item.currency_symbol }}
          </div>
        </template>
        <template #cell(unit_price)="data">
          <div class="text-center">
            {{ priceFormater(data.item.unit_price) }} {{ data.item.currency_symbol }}
          </div>
        </template>
        <template #cell(discount_rate)="data">
          <div class="text-center">
            <span v-if="data.item.discount_rate > 0">
              % {{ data.item.discount_rate }}
            </span>
            <span v-else>-</span>
          </div>
        </template>
        <template #cell(discount_price)="data">
          <div class="text-center">
            <span v-if="data.item.discount_price > 0">
              {{ priceFormater(data.item.discount_price) }} {{ data.item.currency_symbol }}
            </span>
            <span v-else>-</span>
          </div>
        </template>
        <template #cell(total)="data">
          <div class="text-right">
            {{ calcRowTotal(data.item) }} {{ data.item.currency_symbol }}
          </div>
        </template>
      </b-table>
      <b-card-body>
        <b-row>
          <b-col>
            <b-button
              v-b-modal.modal-line-add
              variant="outline-primary"
              size="sm"
              pill
            >
              <FeatherIcon icon="PlusIcon" />
              Ürün Ekle
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer v-if="linesData.length > 0">
        <b-row>
          <b-col class="font-weight-bolder font-medium-2">
            Teklif Toplamı
          </b-col>
          <b-col class="text-right text-primary font-weight-bolder font-medium-2">
            {{ publicTotal }} {{ linesData[0].currency_symbol }}
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col
            md="12"
          ><h6 class="mb-1">
            Özel Şartlar
          </h6></b-col>
          <b-col md="12">
            <b-form-group label="Özel Şartlar Şablonları">
              <v-select
                v-model="id_offer_terms"
                label="title"
                placeholder="Şablon Seçin"
                :options="offerTerms"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <quill-editor
              v-model="formData.terms"
              :options="editorOption"
              class="bg-white text-black-50"
            >
              <div
                id="toolbar"
                slot="toolbar"
              >
                <!-- Add a bold button -->
                <button class="ql-bold">
                  Bold
                </button>
                <button class="ql-italic">
                  Italic
                </button>
                <button
                  class="ql-list"
                  value="ordered"
                />
                <!-- Add font size dropdown -->
                <select class="ql-size">
                  <option value="small" />
                  <!-- Note a missing, thus falsy value, is used to reset to default -->
                  <option selected />
                  <option value="large" />
                  <option value="huge" />
                </select>

                <select class="ql-font">
                  <option selected="selected" />
                  <option value="serif" />
                  <option value="monospace" />
                </select>
                <!-- Add subscript and superscript buttons -->
                <button
                  class="ql-script"
                  value="sub"
                />
                <button
                  class="ql-script"
                  value="super"
                />
              </div>
            </quill-editor>
          </b-col>
        </b-row></b-card-body>
    </b-card>
    <b-button
      v-b-modal.modal-line-add
      variant="danger"
      :disabled="submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
    <b-modal
      id="modal-line-edit"
      ref="update-modal"
      title="Ürün Güncelle"
      ok-title="GÜNCELLE"
      cancel-title="KAPAT"
      centered
      ok-variant="danger"
      cancel-variant="outline-secondary"
      @ok="saveLine"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="Ürün Adı"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="modalData.text"
              placeholder="Ürün Adı"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Miktar">
            <b-form-input
              v-model="modalData.quantity"
              placeholder="Miktar"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Birim Tipi">
            <v-select
              v-model="modalData.id_units"
              label="title"
              :reduce="unit => unit.id"
              placeholder="Birim Tipi"
              :options="units"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Malzeme Birim Fiyatı">
            <cleave
              v-model="modalData.product_price"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              placeholder="Malzeme Birim Fiyatı"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="İşçilik Fiyatı">
            <cleave
              v-model="modalData.labor_price"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              placeholder="İşçilik Fiyatı"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Para Birimi">
            <v-select
              v-model="modalData.id_currencies"
              label="title"
              :reduce="currency => currency.id"
              placeholder="Para Birimi"
              :options="currencies"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="İskonto Oranı">
            <b-form-input
              v-model="modalData.discount_rate"
              placeholder="İskonto Oranı"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="İskonto Tutarı">
            <cleave
              v-model="modalData.discount_price"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              placeholder="İskonto Tutarı"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Toplam Tutar">
            <cleave
              :value="calcModalTotal(modalData)"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              placeholder="Toplam Tutar"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <b-button
            variant="outline-primary"
            size="sm"
            pill
            @click="removeOfferLine(modalData.id)"
          >
            <FeatherIcon icon="TrashIcon" />
            Ürünü Sil
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modal-line-add"
      title="Ürün Ekle"
      ok-title="KAYDET"
      cancel-title="KAPAT"
      centered
      ok-variant="danger"
      cancel-variant="outline-secondary"
      @ok="saveLine"
    >
      <b-row>
        <b-col md="12">
          <b-form-group label="Ürün Seçimi">
            <v-select
              v-model="id_products"
              label="name"
              :filterable="false"
              :options="products"
              @search="onProductsSearch"
            >
              <template slot="no-options">
                Ürün Kodu, Ürün Adı...
              </template>
              <template
                slot="option"
                slot-scope="product"
              >
                <div
                  v-if="product.pcode"
                >
                  <span class="ml-1"><strong>Ürün Kodu:</strong> {{ product.pcode }}</span>
                </div>
                <div
                  v-if="product.title"
                >
                  <span class="ml-1">{{ product.title }}</span>
                </div>
                <div
                  v-if="product.list_price"
                >
                  <span class="ml-1 text-danger"><strong>Liste Fiyatı:</strong> {{ product.list_price }} {{ product.currency }}</span>
                </div>
              </template>
              <template
                slot="selected-option"
                slot-scope="product"
              >
                <div class="selected">
                  {{ product.pcode }} {{ product.title }}
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Ürün Adı"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="modalData.text"
              placeholder="Ürün Adı"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Miktar">
            <b-form-input
              v-model="modalData.quantity"
              placeholder="Miktar"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Birim Tipi">
            <v-select
              v-model="modalData.id_units"
              label="title"
              :reduce="unit => unit.id"
              placeholder="Birim Tipi"
              :options="units"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Malzeme Birim Fiyatı">
            <cleave
              v-model="modalData.product_price"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              placeholder="Malzeme Birim Fiyatı"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="İşçilik Fiyatı">
            <cleave
              v-model="modalData.labor_price"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              placeholder="İşçilik Fiyatı"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Para Birimi">
            <v-select
              v-model="modalData.id_currencies"
              label="title"
              :reduce="currency => currency.id"
              placeholder="Para Birimi"
              :options="currencies"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="İskonto Oranı">
            <b-form-input
              v-model="modalData.discount_rate"
              placeholder="İskonto Oranı"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="İskonto Tutarı">
            <cleave
              v-model="modalData.discount_price"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              placeholder="İskonto Tutarı"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Toplam Tutar">
            <cleave
              :value="calcModalTotal(modalData)"
              class="form-control"
              :raw="true"
              :options="maskOptions.number"
              readonly
              placeholder="Toplam Tutar"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </section>
</template>

<script>
import {
  BCard,
  BButton,
  BCardBody,
  BCardFooter,
  BTable,
  BRow,
  BCol,
  BModal,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  VBModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Cleave from 'vue-cleave-component'
import _ from 'lodash'
import axiosIns from '@/libs/axios'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
// eslint-disable-next-line import/order
import { quillEditor } from 'vue-quill-editor'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'OffersEdit',
  components: {
    BCard,
    BButton,
    BCardBody,
    BCardFooter,
    BTable,
    BRow,
    BCol,
    BModal,
    BFormGroup,
    // eslint-disable-next-line vue/no-unused-components
    BFormInput,
    VBModal,
    BFormDatepicker,
    vSelect,
    Cleave,
    quillEditor,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      submitStatus: false,
      formData: {
        onum: null,
        title: null,
        name: null,
        odate: null,
        sdate: null,
        customer_company: null,
        customer_name: null,
        offer_status: null,
        id_customers: null,
        id_offer_status: null,
        id_user: null,
        created: null,
        modified: null,
      },
      modalData: {},
      linesData: [],
      fields: [
        {
          key: 'text',
          label: 'Ürün Adı',
          thStyle: { textAlign: 'left', verticalAlign: 'middle' },
        },
        {
          key: 'quantity',
          label: 'MİKTAR',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'product_price',
          label: 'MALZEME',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'labor_price',
          label: 'İŞÇİLİK',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'unit_price',
          label: 'BİRİM FİYAT',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'discount_rate',
          label: 'İSKONTO ORANI',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'discount_price',
          label: 'İSKONTO TUTARI',
          thStyle: { width: '160px', textAlign: 'center', verticalAlign: 'middle' },
        },
        {
          key: 'total',
          label: 'TOPLAM',
          thStyle: { width: '160px', textAlign: 'right', verticalAlign: 'middle' },
        },
      ],
      publicTotal: 0,
      maskOptions: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
        theme: 'snow',
      },
      products: [],
      id_products: {},
      id_offer_terms: {},
    }
  },
  computed: {
    saveStatus() {
      const status = this.$store.getters['offers/getOfferSaveStatus']
      return status
    },
    saveLineStatus() {
      const status = this.$store.getters['offers/getOfferLineSaveStatus']
      return status
    },
    removeLineStatus() {
      const status = this.$store.getters['offers/getOfferLineRemoveStatus']
      return status
    },
    offerData() {
      return this.$store.getters['offers/getOffer']
    },
    offerLinesData() {
      return this.$store.getters['offers/getOfferLines']
    },
    offerLineData() {
      return this.$store.getters['offers/getOfferLine']
    },
    units() {
      const data = this.$store.getters['units/getUnits']
      return data
    },
    currencies() {
      const data = this.$store.getters['currencies/getCurrencies']
      return data
    },
    offerStatuses() {
      const data = this.$store.getters['offerStatus/getOffer_statuses']
      return data
    },
    offerTerms() {
      const data = this.$store.getters['offerTerms/getOffer_terms']
      return data
    },
  },
  watch: {
    saveStatus(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.formData = {
          onum: null,
          title: null,
          odate: null,
          id_customers: null,
          products: [],
        }
        this.$router.push(`/offers/view/${val.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.submitStatus = false
    },
    saveLineStatus(val) {
      if (val.status === true) {
        this.modalData = {}
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
        this.getOfferLines()
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
        this.getOfferLines()
      }
      this.submitStatus = false
    },
    removeLineStatus(val) {
      if (val === true) {
        this.modalData = {}
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Silme işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
        this.getOfferLines()
      } else if (val === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Silme işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
        this.getOfferLines()
      }
      this.$refs['update-modal'].hide()
      this.submitStatus = false
    },
    offerData(val) {
      this.setFormData(val)
    },
    offerLinesData(val) {
      this.setLinesData(val)
    },
    offerLineData(val) {
      this.setLineData(val)
    },
    id_products(val) {
      if (!val) {
        this.products = []
      } else {
        this.modalData = {
          text: val.title,
          product_price: val.list_price,
          labor_price: val.labor_price,
          id_currencies: val.id_currencies,
          quantity: 1,
          id_offers: this.$route.params.id,
        }
      }
    },
    id_offer_terms(val) {
      if (val) {
        this.formData.terms = val.content
      }
    },
  },
  created() {
    this.getOffer()
    this.getOfferLines()
    this.getUnits()
    this.getCurrencies()
    this.getOfferStatuses()
    this.getOfferTerms()
  },
  updated() {
    this.calcPublicTotal()
  },
  methods: {
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
    /* Products Search Start --> */
    onProductsSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.productSearch(loading, search, this)
      }
    },
    productSearch: _.debounce((loading, search, vm) => {
      const data = JSON.stringify({
        select: [
          'products.id AS id',
          'products.pcode AS pcode',
          'products.title AS title',
          'products.list_price AS list_price',
          'products.labor_price AS labor_price',
          'products.id_currencies AS id_currencies',
          'brands.title AS brand',
          'currencies.symbol AS currency',
        ],
        or_like: {
          'products.pcode': search,
          'products.title': search,
        },
        limit: 50,
      })
      axiosIns
        .post('/products/getData', data)
        .then(response => {
          // eslint-disable-next-line no-param-reassign
          vm.products = response.data.data
          loading(false)
        })
        .catch(error => console.error(error))
    }, 350),
    /* <-- Products Search End */
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    getUnits() {
      this.$store.dispatch('units/unitsList', { select: ['units.id AS id', 'units.title AS title'] })
    },
    getCurrencies() {
      this.$store.dispatch('currencies/currenciesList')
    },
    getOfferStatuses() {
      this.$store.dispatch('offerStatus/offer_statusesList')
    },
    getOffer() {
      this.$store.dispatch('offers/offerView', this.$route.params.id)
    },
    getOfferLines() {
      this.$store.dispatch('offers/offerLinesList', {
        where: {
          'offer_lines.id_offers': this.$route.params.id,
        },
      })
    },
    getOfferLine(id) {
      this.modalData = {}
      this.$store.dispatch('offers/offerLineView', id)
    },
    removeOfferLine(id) {
      this.submitStatus = true
      this.$store.dispatch('offers/offerLineRemove', id)
    },
    priceFormater(price) {
      return new Intl.NumberFormat('tr-TR').format(price)
    },
    calcRowTotal(data) {
      let total = 0
      if (data.quantity) {
        const quantity = Number(data.quantity)
        const listPrice = Number(data.product_price)
        const laborPrice = Number(data.labor_price)
        total = (listPrice + laborPrice) * quantity
        if (data.discount_price) {
          total -= data.discount_price
        }
        if (data.discount_rate) {
          const discount = (total * data.discount_rate) / 100
          total -= discount
        }
        // eslint-disable-next-line no-param-reassign
        data.rowTotal = total
      }
      total = total.toFixed(2)
      return new Intl.NumberFormat('tr-TR').format(total)
    },
    calcModalTotal(data = null) {
      let total = 0
      if (!data) {
        // eslint-disable-next-line no-param-reassign
        data = this.modalData
      }
      if (data.quantity) {
        const quantity = Number(data.quantity)
        const listPrice = Number(data.product_price)
        const laborPrice = Number(data.labor_price)
        total = (listPrice + laborPrice) * quantity
        if (data.discount_price) {
          total -= data.discount_price
        }
        if (data.discount_rate) {
          const discount = (total * data.discount_rate) / 100
          total -= discount
        }
        // eslint-disable-next-line no-param-reassign
        data.rowTotal = total
      }
      total = total.toFixed(2)
      return total
    },
    calcPublicTotal() {
      let result = 0
      if (this.linesData.length > 0) {
        const lines = this.linesData
        const total = []
        lines.forEach(e => {
          if (e.rowTotal) {
            total.push(e.rowTotal)
          }
        })
        result = total.reduce((a, b) => a + b, 0)
        result = new Intl.NumberFormat('tr-TR').format(result)
      }
      this.publicTotal = result
    },
    getOfferTerms() {
      this.$store.dispatch('offerTerms/offer_termsList')
    },
    setFormData(data) {
      this.formData = data
    },
    setLinesData(data) {
      this.linesData = data
    },
    setLineData(data) {
      if (data) {
        const total = this.calcModalTotal(data)
        this.modalData = data
        this.modalData.total = total
      }
    },
    saveLine() {
      this.submitStatus = true
      this.modalData.id_offers = this.formData.id
      this.$store.dispatch('offers/offerLineSave', this.modalData)
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('offers/offerSave', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@core/scss/base/pages/app-invoice.scss";
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
